import { useEffect, useRef, useState } from 'react';

// Generated previews use the normal video soundtrack, not a second audio player.
export function SoundVideo({ src, style, className }) {
  const ref = useRef(null);
  const [message, setMessage] = useState('');
  useEffect(() => { setMessage(''); }, [src]);
  const play = async () => {
    const video = ref.current;
    video.muted = false;
    video.volume = 1;
    try {
      await video.play();
      setMessage('');
    } catch (error) {
      setMessage(error.name === 'NotAllowedError' ? 'Use the video play control to allow sound.' : 'Playback failed. Please reload the preview.');
    }
  };
  const chooseOutput = async () => {
    try {
      const device = await navigator.mediaDevices.selectAudioOutput();
      await ref.current.setSinkId(device.deviceId);
      setMessage('Sound output selected.');
    } catch (error) {
      setMessage(error.name === 'NotAllowedError' ? 'Sound output permission was not granted.' : 'Could not select that speaker. Check your device sound settings.');
    }
  };
  const canChooseOutput = typeof navigator.mediaDevices?.selectAudioOutput === 'function' && typeof HTMLMediaElement.prototype.setSinkId === 'function';
  return <div>
    <video key={src} ref={ref} src={src} controls playsInline preload="metadata" style={style} className={className}
      onError={() => setMessage('The video could not load or decode. Please reload the preview.')} />
    <div className="mt-2 flex flex-wrap items-center gap-3 text-sm">
      <button type="button" onClick={play} className="rounded border px-3 py-2">Play with sound</button>
      {canChooseOutput && <button type="button" onClick={chooseOutput} className="rounded border px-3 py-2">Choose speaker</button>}
      <span role="status" aria-live="polite">{message}</span>
    </div>
  </div>;
}
